import VipInfoCard from "@/components/bussiness/MyGadget/VipInfoCard";
import { ImageWithPlaceHolder } from "@/components/Image/WithPlaceHolder";
import { NSlider } from "@/components/NSlider";
import { DistributeFreeCoinModal } from "@/components/Onboarding/mini";
import TextSwitcher from "@/components/TextSwitcher";
import { Close, Check } from "@/components/Icons";
import NewPayModal from "@/modules/payment/components/NewPayModal";
import PayModalWithTable, { TableData } from "@/modules/payment/components/PayModalWithTable";
import PriceCard from "@/modules/payment/components/PriceCard";
import VipUpgradeModal from "@/modules/payment/components/VipUpgradeModal";
import { Box, Flex, Text } from "@chakra-ui/react";
// import { HeartCoinPayment } from "@/modules/payment/HeartCoinPayment";

const mock: TableData = {
  header: {
    items: ["会员权益对比", "非会员用户", "会员用户"],
    primaryKeyStyle: { color: "#999999" },
  },
  contents: [
    {
      title: "画宇宙功能",
      rows: [
        {
          items: [
            "核心功能",
            <Check boxSize="16px" key={`核心功能${1}`} />,
            <Check boxSize="16px" key={`核心功能${2}`} />,
          ],
        },
        {
          items: [
            "使用小模型",
            <Check boxSize="16px" key={`使用小模型${1}`} />,
            <Check boxSize="16px" key={`使用小模型${2}`} />,
          ],
        },
        {
          items: [
            "不限量使用",
            <Close boxSize="16px" key={`不限量使用${1}`} />,
            <Check boxSize="16px" key={`不限量使用${2}`} />,
          ],
        },
        {
          items: [
            "算力加速",
            <Close boxSize="16px" key={`算力加速${1}`} />,
            <Check boxSize="16px" key={`算力加速${2}`} />,
          ],
        },
        {
          items: [
            "不限制提交任务数",
            <Close boxSize="16px" key={`不限制提交任务数${1}`} />,
            <Check boxSize="16px" key={`不限制提交任务数${2}`} />,
          ],
        },
        {
          items: [
            "批量生成多张",
            <Close boxSize="16px" key={`批量生成多张${1}`} />,
            <Check boxSize="16px" key={`批量生成多张${2}`} />,
          ],
        },
      ],
    },
    {
      title: "第三方模型",
      rows: [
        {
          items: [
            "Draft 动漫模型",
            <Check boxSize="16px" key={`Draft 动漫模型${1}`} />,
            <Check boxSize="16px" key={`Draft 动漫模型${2}`} />,
          ],
        },
        {
          items: [
            "百度文心模型",
            <Check boxSize="16px" key={`百度文心模型${1}`} />,
            <Check boxSize="16px" key={`百度文心模型${2}`} />,
          ],
        },
        {
          items: [
            "社区大模型",
            <Check boxSize="16px" key={`社区大模型${1}`} />,
            <Check boxSize="16px" key={`社区大模型${2}`} />,
          ],
        },
        {
          items: [
            "画力星优惠价",
            <Close boxSize="16px" key={`画力星优惠价${1}`} />,
            <Check boxSize="16px" key={`画力星优惠价${2}`} />,
          ],
        },
      ],
    },
  ],
};

export default function Test() {
  return (
    <Box w="100vw" h="100vh">
      <TextSwitcher
        defaultSelected={0}
        switchList={[
          "哈哈哈",
          "呼呼呼",
          "你打我呀",
          "这是一个超级长的按钮看看有没有问题",
          "再多加几个",
          "嘿嘿嘿",
          <span key={"a"} style={{ color: "red" }}>
            这是个span
          </span>,
        ]}
        onChange={console.log}
        w="300px"
      />
      <NSlider max={1} min={0} defaultValue={0.5} onChange={console.log} label="原图相似度：" />
      <ImageWithPlaceHolder
        w="300px"
        h="300px"
        url="https://ailabcdn.nolibox.com/tmp/a8450f983b184b989c247edcbef08ce9.png"
        placeholderText="请选中画板上的图片"
      />
      <PayModalWithTable
        isOpen={false}
        onClose={() => null}
        title="asdsad"
        tableData={mock}
        content={
          <Flex flexDirection="column">
            <Flex w="500px" gap="16px" wrap="wrap">
              {[
                <Box w="218px" key={1}>
                  <PriceCard
                    title={"test1"}
                    oldPrice={"100"}
                    curPrice={"90"}
                    unitPrice={"元"}
                    selected={true}
                    onClick={() => null}
                  />
                </Box>,
                <Box w="218px" key={1}>
                  <PriceCard
                    title={"test1"}
                    oldPrice={"100"}
                    curPrice={"90"}
                    unitPrice={"元"}
                    selected={true}
                    onClick={() => null}
                  />
                </Box>,
              ]}
            </Flex>
            <Text m="18px 0" fontSize="12px" lineHeight="22px" color="#999999">
              * 付费的最终解释权归计算美学所有
            </Text>
          </Flex>
        }
      />
      <VipInfoCard title="标题" info="画力星" btnText="购买" onBtnClick={() => null} />
      {/* <DistributeFreeCoinModal /> */}
      {/* <VipUpgradeModal /> */}
      {/* <NewPayModal isOpen={true} onClose={() => null} isVip={true} expire={new Date()} /> */}
      {/* <HeartCoinPayment open /> */}
    </Box>
  );
}
